// utils/selectStyles.js

export const getAsyncSelectStyles = ({
  minWidth = "200px",
  maxWidth = "100%",
  autoWidth = true,
  fitInFlex = true,
} = {}) => {
  return {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),

    control: (provided, state) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      minWidth,
      width: autoWidth ? "auto" : undefined,
      maxWidth,
      backgroundColor: "#f2f4f7",
      border: "0px solid #e2e8f0",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 0 2px #bfdbfe" : "none",
      "&:hover": {
        borderColor: "#cbd5e1",
        cursor: "pointer",
      },
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      ...(fitInFlex ? { flex: "1 1 auto" } : {}),
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 12px",
      height: "40px",
      maxWidth,
      flexWrap: "nowrap",
    }),

    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      color: "#1e293b",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),

    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: "500",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "100%",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#04080B",
      fontSize: "14px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "8px",
      color: "#04080B",
    }),

    clearIndicator: (provided) => ({
      ...provided,
      padding: "8px",
      color: "#64748b",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#f2f4f7",
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isSelected ? "#e2e8f0" : "#f2f4f7",
      color: "#1e293b",
      "&:hover": {
        backgroundColor: "#e2e8f0",
      },
    }),

    menu: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "4px",
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
      border: "0px solid #e2e8f0",
      zIndex: 9999,
    }),

    menuList: (provided) => ({
      ...provided,
      padding: "4px 0",
    }),
  };
};

// utils/asyncSelectStyles.js

export const getAsyncSelectStylesForm = ({
  usePortal = false, // New option to enable portal rendering
} = {}) => {
  const baseStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "56px",
      paddingInline: "6px",
      borderRadius: "8px",
      display: "flex",
      justifyContent: "space-between",
      background: "#f9fafb",
      border: "1px solid #eaecf0",
      fontFamily: "Poppins, sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
      textAlign: "start",
      color: "#111827",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#A0A0A0",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#04080b",
      marginInlineStart: "0",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: usePortal ? 9999 : 3, // Higher z-index when using portal
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? "#f3f4f6" : "#fff",
      color: "#04080b",
      paddingBlock: "10px",
      paddingInline: "16px",
      cursor: "pointer",
      fontSize: "12px",
      lineHeight: "18px",
      textAlign: "start",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
  };

  // Add portal-specific styles only when usePortal is true
  if (usePortal) {
    baseStyles.menuPortal = (provided) => ({
      ...provided,
      zIndex: 9999,
    });
  }

  return baseStyles;
};

// Helper function to get portal props when needed
export const getAsyncSelectPortalProps = (usePortal = false) => {
  if (!usePortal) return {};

  return {
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    menuPlacement: "auto",
  };
};
